export const TOAST_TEXT = {
  // SIGN UP
  SIGNUP_SUCCESS: '🥳 註冊成功 🎉🎉🎉',
  SIGNUP_ACCOUNT_EXISTED: '🥶 使用者帳戶已存在',
  SIGNUP_FAIL: '😓 註冊失敗 請重新嘗試',

  // LOGIN
  LOGIN_SUCCESS: '🥳 登入成功',
  LOGIN_FAIL: '😓 登入失敗 請重新嘗試',

  // LOGOUT
  LOGOUT_SUCCESS: '👋 登出成功',
  LOGOUT_FAIL: '🤭 登出失敗 請稍候再嘗試',

  // SETTINGS
  SETTINGS_FAIL: '🤔 無法取得使用者設定 請重新登入',

  // LABELS
  LABEL_UPDATE_SUCCESS: '標籤更新成功 😊',
  LABEL_DELETE_SUCCESS: '標籤刪除成功 😳',
  LABELS_FAIL: '🤔 無法取得使用者標籤 請重新登入',

  // MEMOS
  MEMO_ADD_SUCCESS: '記事新增成功 😳',
  MEMO_ADD_FAIL: '記事新增失敗 請重整再試 🥶',

  MEMO_UPDATE_FAIL: '記事更新失敗 請重整再試 🥶',

  MEMO_DELETE_SUCCESS: '記事刪除成功 😳',
  MEMO_DELETE_FAIL: '記事刪除失敗 請重整再試 🥶',

  MEMOS_FAIL: '🤔 無法取得使用者記事 請重整再試',
};
